import { useState } from "react";
import { Modal, Form, Button, ListGroup } from "react-bootstrap";
import swal from "sweetalert";
import { aiService } from "../../service/api.service";
import { InlineLoader } from "../loader";

const ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx", ".txt"];

function AddKnowledgeBaseModal({ show, handleClose, agent, onSuccess }) {
  const [files, setFiles] = useState([]);
  const [loader, setLoader] = useState(false);

  const resetAndClose = () => {
    setFiles([]);
    setLoader(false);
    handleClose();
  };

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    const invalid = selected.find((f) => {
      const ext = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
      return !ALLOWED_EXTENSIONS.includes(ext);
    });
    if (invalid) {
      swal({ icon: "error", text: "Only pdf, doc, docx, txt files are allowed." });
      e.target.value = "";
      setFiles([]);
      return;
    }
    setFiles(selected);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!files.length) {
      swal({ icon: "error", text: "Please select at least one file." });
      return;
    }
    setLoader(true);
    try {
      for (const file of files) {
        const form = new FormData();
        form.append("files", file);
        form.append("agent_id", agent._id);
        await aiService.addKnowledgeBase(form);
      }
      swal({ icon: "success", text: "Knowledge base uploaded successfully." });
      onSuccess && onSuccess();
      resetAndClose();
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) {
        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
        });
      } else {
        swal({ icon: "error", text: error?.response?.data?.message || "Error uploading file." });
      }
    }
  };

  return (
    <Modal show={show} onHide={resetAndClose} className="premium-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Knowledge Base{agent?.name ? ` - ${agent.name}` : ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleUpload}>
          <Form.Group className="mb-3">
            <Form.Label>Upload Files</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".pdf,.doc,.docx,.txt"
              onChange={handleFileChange}
            />
            <Form.Text className="text-muted">
              Allowed file types: pdf, doc, docx, txt
            </Form.Text>
          </Form.Group>

          {files.length > 0 && (
            <ListGroup className="mb-3">
              {files.map((f, i) => (
                <ListGroup.Item key={i}>{f.name}</ListGroup.Item>
              ))}
            </ListGroup>
          )}

          <div className="d-flex gap-2">
            <Button variant="primary" type="submit" disabled={loader}>
              {loader ? <InlineLoader /> : "Upload"}
            </Button>
            <Button variant="secondary" onClick={resetAndClose} disabled={loader}>
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AddKnowledgeBaseModal;
